export default {
  title: 'Uw eigen domein',
  description:
    'Laat de apps van uw team draaien op een domein dat van u is in plaats van op het gedeelde adres. U koppelt het domein één keer: het dashboard, het bestelportaal, de website-editor en de websitestudio krijgen elk een adres daaronder.',
  read_only_description:
    'Het domein waarop deze partner zijn apps laat draaien. Alleen de partner kan het koppelen of ontkoppelen.',
  read_only_empty: 'Deze partner heeft geen domein gekoppeld.',
  not_connected: {
    label: 'Domein',
    hint: 'Het domein dat van u is, zonder www — bijvoorbeeld uwmerk.nl. Daarna voegt u de getoonde DNS-records toe bij uw domeinprovider.',
    placeholder: 'uwmerk.nl',
    connect: 'Koppelen',
  },
  apps: {
    dashboard: 'Dashboard',
    oms: 'Bestelportaal',
    storefront: 'Website-editor',
    website_studio: 'Websitestudio',
  },
  status: {
    active: 'Live',
    pending: 'Wacht op DNS',
    failed: 'Actie vereist',
    disabled: 'Ontkoppeld',
  },
  records: {
    title: 'Voeg deze DNS-records voor {{root}} toe bij uw domeinprovider',
  },
  instructions: {
    title: 'Zo voegt u de records toe',
    step_provider:
      'Log in waar de DNS van {{root}} wordt beheerd — meestal bij de partij waar u het domein hebt gekocht, of bij een DNS-dienst zoals Cloudflare.',
    step_add:
      'Open de DNS-instellingen van {{root}} en voeg elk record hieronder toe: kies het type en kopieer de naam en de waarde precies zoals ze zijn. Laat de TTL op de standaardwaarde staan.',
    step_check:
      'Sla de records op en klik op „{{button}}”. De meeste providers publiceren wijzigingen binnen enkele minuten; sommige doen er tot 48 uur over.',
    tip_name:
      'In het naamveld verwachten de meeste providers alleen het deel vóór {{root}}, vetgedrukt weergegeven. Vraagt uw provider om de volledige naam, kopieer dan die eronder.',
    tip_cloudflare:
      'Zet bij Cloudflare de CNAME-records op „Alleen DNS” (grijze wolk). Een record via de proxy verbergt de CNAME, waardoor het domein niet kan worden geverifieerd.',
    tip_existing: 'Laat uw bestaande records voor {{root}} en www ongewijzigd — uw website blijft gewoon werken.',
  },
  summary: {
    live: 'Uw dashboard is live op {{host}}.',
    pending:
      'We controleren uw DNS-records regelmatig. Het kan tot 48 uur duren voordat nieuwe records worden gevonden.',
    failed:
      'Sommige records konden niet worden geverifieerd. Corrigeer de hieronder gemarkeerde records en controleer opnieuw.',
    relogin: 'Zodra {{host}} live is, logt uw team daar in. Bij het eerste bezoek moeten ze opnieuw inloggen.',
  },
  buttons: {
    check_again: 'Opnieuw controleren',
    disconnect: 'Ontkoppelen',
    retry: 'Opnieuw proberen',
  },
  disconnect_confirm: {
    title: '{{root}} ontkoppelen?',
    description: 'Uw apps gaan terug naar het gedeelde adres en links op {{root}} werken niet meer.',
    ok: 'Ontkoppelen',
  },
  toasts: {
    load_error: 'Uw domein kon niet worden geladen.',
    load_error_read_only: 'Het domein van deze partner kon niet worden geladen.',
    connected: 'Domein gekoppeld. Voeg de DNS-records hieronder toe.',
    connect_failed: 'Het domein kon niet worden gekoppeld.',
    check_started: 'Uw DNS-records worden gecontroleerd.',
    check_failed: 'De controle kon niet worden gestart. Probeer het over een minuut opnieuw.',
    disconnected: 'Domein ontkoppeld.',
    disconnect_failed: 'Het domein kon niet worden ontkoppeld.',
  },
};
